import { Box, SxProps, TableCell, TableRow } from '@mui/material';
import { FunctionComponent } from 'react';
import { Loader } from '../../../../ui/components';
import { ChartSettings } from '../../../chart-settings/model';
import { useAvailabilityMeasurementsApiGet, useCpuMeasurementsApiGet } from '../../hooks';
import { MonitoredDeviceModel } from '../../model';
import { CpeStatisticsTableRowChart } from '../CpeStatisticsTableRowChart/CpeStatisticsTableRowChart';

interface Props {
  customerId: number | null;
  device: MonitoredDeviceModel;
  chartSettings: ChartSettings;
}

export const CpeStatisticsTableRow: FunctionComponent<Props> = ({ device, customerId, chartSettings }) => {
  const {
    data: cpuTimeSeriesMeasurements,
    isFetched: isCpuMeasurementsFetched,
    isFetching: isCpuMeasurementsFetching,
  } = useCpuMeasurementsApiGet(customerId, device.deviceId, chartSettings, 'table');
  const {
    data: availabilityTimeSeriesMeasurements,
    isFetched: isAvailabilityMeasurementsFetched,
    isFetching: isAvailabilityMeasurementsFetching,
  } = useAvailabilityMeasurementsApiGet(customerId, device.deviceId, chartSettings, 'table');
  const containerSx: SxProps = { display: 'flex', justifyContent: 'center', alignItems: 'center', columnGap: '4rem' };
  const chartSx: SxProps = { width: '33%' };
  const isFetching = isAvailabilityMeasurementsFetching || isCpuMeasurementsFetching;
  const isFetched = isAvailabilityMeasurementsFetched || isCpuMeasurementsFetched;

  return <TableRow style={{ background: '#EFF6FF' }} className={'MuiTableRowExpanded'}>
    <TableCell colSpan={7}>
      { isFetching && <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader loading={true} />
      </Box> }
      { !isFetching && isFetched && <Box sx={containerSx} data-testid={'charts'}>
        { (cpuTimeSeriesMeasurements || availabilityTimeSeriesMeasurements) && <>
          <Box sx={chartSx}>
            { cpuTimeSeriesMeasurements !== null &&
            <CpeStatisticsTableRowChart
              customerId={ customerId }
              dataType='cpuUsage'
              data={ cpuTimeSeriesMeasurements }
              chartSettings={ chartSettings }
              device={device} /> }
          </Box>
          <Box sx={chartSx}>
            { availabilityTimeSeriesMeasurements !== null && 
            <CpeStatisticsTableRowChart
              customerId={ customerId }
              dataType='availability'
              data={ availabilityTimeSeriesMeasurements }
              chartSettings={ chartSettings }
              device={ device } /> }
          </Box>
        </> }
      </Box >}
    </TableCell>
  </TableRow>;
};